<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [header]="'Mot de passe oublié'"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  (onHide)="onDialogHide()"
  styleClass="forgot-password-modal">
  <p>Demande de réinitialisation de mot de passe</p>
  <p>Un e-mail va vous être renvoyer avec un lien de réinitialisation.</p>
  <p>Pensez à vérifier vos spams.</p>
  <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
    <app-input-field [fieldConfig]="emailField" [formGroup]="forgotPasswordForm"></app-input-field>
    <app-input-field-error [control]="forgotPasswordForm.get('email')" [fieldName]="'email'"></app-input-field-error>
    <div class="submit-button">
      <button type="submit" class="forgot-password-btn" [disabled]="forgotPasswordForm.invalid">Envoyer</button>
    </div>
  </form>
</p-dialog>
